import React from 'react';
import {useNavigate} from 'react-router-dom';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {RefundEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';

import {ConsultRefundV2Provider} from './hooks/useConsultRefundContext';
import {ListStep} from './components/ListStep';

const {title} = translations['pt-br'].privateFlow.consultRefund;

function ConsultRefundV2Content() {
	const navigate = useNavigate();
	const goToRefund = () => navigate(RefundEnum.REFUND);

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				dataTagId={{
					closeButton: RefundTaggingEnum.CLICK_FECHAR_CONSULTAR_REEMBOLSO,
					backButton: RefundTaggingEnum.CLICK_VOLTAR_CONSULTAR_REEMBOLSO,
				}}
				variant="subRoute"
				title={title}
				handleBack={goToRefund}
				handleClose={goToRefund}
			/>
			<ListStep />
		</PageWrapperLayout>
	);
}

export function ConsultRefundV2() {
	return (
		<ConsultRefundV2Provider>
			<ConsultRefundV2Content />
		</ConsultRefundV2Provider>
	);
}
